<div class="uk-grid-small uk-flex uk-flex-middle sous-titre">
  <div>
    <div class="uk-width-1-1">
      Apprenants inscrits
    </div>
    <div *ngIf="headerData">
      <p class="uk-margin-remove">{{ headerData.apprenant_ins }}<i class="material-icons">person</i></p>
    </div>
    <div>
      <div>{{ headerData ? headerData.pourcentage : 0 }}%</div>
      <progress
        class="progress-bar"
        id="avancement2"
        value="{{ headerData ? headerData.pourcentage : 0 }}"
        max="100"
      ></progress>
    </div>
  </div>
  <div *ngIf="surchargeHeureAcadomia.b_actif">
    <div class="uk-width-1-1">
      Volume horaire de la session
    </div>
    <div *ngIf="headerData">
      <p class="uk-margin-remove">{{ headerData.duree_heure }}<i class="material-icons">watch_later</i></p>
    </div>
  </div>
  <div *ngIf="surchargeHeureAcadomia.b_actif">
    <div class="uk-width-1-1">
      Reste à planifier
    </div>
    <div *ngIf="headerData">
      <p class="uk-margin-remove">{{ headerData.duree }}<i class="material-icons">calendar_today </i></p>
    </div>
    <div>
      <div>{{ headerData ? headerData.pourcentage_heure : 0 }}%</div>
      <progress
        class="progress-bar"
        [ngClass]="alerteVolumeHeureBar"
        id="avancement2"
        value="{{ headerData ? headerData.pourcentage_heure : 0 }}"
        max="100"
      ></progress>
      <p *ngIf="alerteVolumeHeure" [ngClass]="alerteVolumeHeure">
        <i class="material-icons" [ngClass]="alerteVolumeHeure">warning_amber</i>Le volume horaire devant être planifié
        a été atteint
      </p>
    </div>
  </div>
  <div class="uk-text-align uk-margin-auto-left">
    <div class="test">
      <label>
        Statut de la session
        <span
          class="capsule uk-margin-small-left"
          [ngStyle]="{ 'background-color': headerData ? headerData.colorcode : '' }"
        >
          {{ headerData ? headerData.statut_session : '' }}</span>
      </label>
    </div>
    <!-- <div *ngIf="headerData" class="clore-one">
      <button kendoButton class="k-button k-primary" (click)="openPopup()" *ngIf="headerData.auto === true"
        >Clore la session</button>
    </div> -->
  </div>
</div>

<!-- Popup clore session -->
<div class="example-wrapper">
  <kendo-dialog title="Confirmation de clôture" *ngIf="open" (close)="close()" [minWidth]="250" [width]="600">
    <p class="text-popup">
      <span uk-icon="icon: warning; ratio: 5" class="icon-style"></span><br /><br />
      Attention, cette action est définitive. Êtes-vous certain(e) de vouloir clore le traitement administratif de cette
      session ?
    </p>
    <kendo-dialog-actions>
      <button kendoButton class="k-button k-primary " (click)="close()">Annuler</button>
      <button kendoButton class="k-button k-primary " (click)="closeSession()">Je confirme !</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>

<div class="example-wrapper" *ngIf="popupError">
  <kendo-dialog title="Confirmation de clôture" (close)="close()" [minWidth]="250" [width]="600">
    <p class="text-popup">
      <span class="k-icon k-i-warning" class="icon-style"></span><br /><br />
      une Erreur interne est survenue..
    </p>
    <kendo-dialog-actions>
      <button class="k-button k-primary" (click)="close()">ok</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>